import { render } from "./modalRoot.vue?vue&type=template&id=806d36d6&scoped=true&ts=true"
import script from "./modalRoot.vue?vue&type=script&lang=ts"
export * from "./modalRoot.vue?vue&type=script&lang=ts"

import "./modalRoot.vue?vue&type=style&index=0&id=806d36d6&scoped=true&lang=scss"

import exportComponent from "D:\\J\\workspace\\FusionServer\\QUA\\Manitou.FusionServer.Web.DiagPortalFront\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-806d36d6"]])

export default __exports__